

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class OzRichDesktopModal extends Vue {
  $refs!: {
    header: HTMLHeadElement
    modalBody: HTMLDivElement
    modalContainer: HTMLDivElement
    modalContainerInner: HTMLDivElement
    modalContainerInnerWrapper: HTMLDivElement
  }

  @Prop({ default: 768 }) windowHeight!: number
  @Prop({ default: false }) xTopLine!: boolean
  @Prop() fullSize!: boolean
  /**
   * Desktop modal minimum height
   */
  @Prop({ default: 0 }) desktopViewMinHeight!: number
  /**
   * Starting click location based relative to window. For desktop to achieve zoom from click animation
   */
  @Prop({ default: undefined }) startingClickLocation!: { top: number; left: number } | undefined

  /**
   *  Tailwindcss width class for desktop mode
   *  `w-180` is for the content picker
   *  `w-128` is for the reaction edit modal
   *  `w-82` is the default for all screens
   *    - This allows us to use the same width for all devices.
   *    - 328px = 360px - (16px * 2)
   */
  @Prop({ default: 'w-180' }) desktopModeWidthClass!: 'w-180' | 'w-128' | 'w-82'

  @Prop({ default: 'auto' }) isDarkMode!: true | false | 'auto'

  /**
   * Determines whether we should compute a fix height for the modal
   */
  @Prop({ default: true }) shouldFixHeight!: boolean

  /**
   * Determines whether the modal should fade in when opened
   */
  @Prop({ default: true }) shouldFadeIn!: boolean

  // tablet/desktop
  mountedHeight = 0

  cancel(extra = undefined): void {
    this.$emit('cancel', extra)
  }

  @Watch('fullSize')
  handleResize(fullSize: boolean): void {
    if (!this.shouldFixHeight) {
      return
    }
    const modalContainer = this.$refs.modalContainer
    // For tablet/desktop, we simply change the modal height
    if (fullSize) {
      modalContainer.style.height = this.windowHeight - 112 + 'px'
    } else {
      modalContainer.style.height = this.mountedHeight + 'px'
    }
    return
  }

  computeHeight(): void {
    if (!this.shouldFixHeight) {
      return
    }
    const modalContainer = this.$refs.modalContainer
    // Starting minimum height for the modal
    this.mountedHeight = Math.max(this.desktopViewMinHeight, modalContainer.clientHeight)
    modalContainer.style.height = this.mountedHeight + 'px'
  }

  animateIn(): void {
    const modalContainer = this.$refs.modalContainer
    if (!this.startingClickLocation) {
      modalContainer.style.animationName = 'modal-fade'
      // animation-name: modal-fade;
      return
    }

    const centerOfScreen = {
      top: window.innerHeight / 2,
      left: window.innerWidth / 2,
    }
    const startOffset = {
      top: this.startingClickLocation.top - centerOfScreen.top,
      left: this.startingClickLocation.left - centerOfScreen.left,
    }
    const startTransformation = {
      scale: 0,
      translate3d: {
        y: startOffset.top,
        x: startOffset.left,
        z: 0,
      },
    }
    const endTransformation = {
      scale: 1,
      translate3d: { x: 0, y: 0, z: 0 },
    }

    function generateTransformString(details: {
      scale: number
      translate3d: { x: number; y: number; z: number }
    }): string {
      return ` translate3d(${details.translate3d.x}px, ${details.translate3d.y}px, ${details.translate3d.z}px) scale(${details.scale}) `
    }

    modalContainer.style.transition = 'none'
    modalContainer.style.transformOrigin = 'center'
    modalContainer.style.transform = generateTransformString(startTransformation)
    setTimeout(() => {
      /**
       * Decelerated easing for incoming element
       * @see https://material.io/design/motion/speed.html#easing
       */
      modalContainer.style.transition = 'all 300ms cubic-bezier(0.0, 0.0, 0.2, 1)'
      modalContainer.style.transform = generateTransformString(endTransformation)
    }, 1)
  }

  mounted(): void {
    this.computeHeight()
    this.animateIn()
  }
}
